module.exports = __webpack_public_path__ + "static/media/image_5.7369e19e.png";